import { fetch } from '../utils/request';

const BaseUrl = process.env.MONO_BASE;

const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  getProduction(id) {
    return fetch(getUrl(`/productions/${id}`));
  },
};
